import * as types from './types';
import { loading, success, handleErrorException } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

export const getKitchenItems = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.KITCHEN_ITEMS_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        'CentralKitchen/GetKitchenItems'
      );
      dispatch(success(types.KITCHEN_ITEMS_DATA, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching item list. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.KITCHEN_ITEMS_FETCHING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.KITCHEN_ITEMS_LOADING, false));
    }
  };
};

export const clearKitchenItemErrors = () => {
  return { type: types.KITCHEN_ITEMS_CLEAR_ERRORS };
};

export const saveKitchenItems = payload => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.KITCHEN_ITEMS_SUBMITTING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'CentralKitchen/WriteKitchenItems',
        payload
      );
      dispatch(success(types.KITCHEN_ITEMS_SUBMIT));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while saving prepare in-house preferences. Please try again',
      };
      dispatch(
        handleErrorException(ex, types.KITCHEN_ITEMS_SUBMIT_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.KITCHEN_ITEMS_SUBMITTING, false));
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenitems/state/actions.js